// extracted by mini-css-extract-plugin
module.exports = {"root":"PermitsByTransport_root__2pmgI","header":"PermitsByTransport_header__3rlo5","content":"PermitsByTransport_content__1Zt5q"};